import(/* webpackMode: "eager", webpackExports: ["I18nClientProvider"] */ "/opt/buildhome/repo/lib/i18n/I18nClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider","useTranslation","useTranslationOptional"] */ "/opt/buildhome/repo/lib/i18n/I18nContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/@livekit+components-styles@1.2.0/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/buildhome/repo/node_modules/.pnpm/react-hot-toast@2.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/@livekit+components-styles@1.2.0/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
